<template>
  <div class="relative w-full">
    <profile ref="profile" :show="true" @next="next" @leave="leave" />
  </div>
</template>

<script>
import leave from '@/mixins/leave';
import ApiActions from '@/modules/api-actions';
import ScanProcess from '@/modules/scan-process';

import Profile from '@/components/MobileScan2/Tutorial/Profile.vue';

export default {
  name: 'UserProfile',
  mixins: [leave],
  components: {
    Profile,
  },
  methods: {
    async setProfile() {
      if (!this.$refs.profile.isEdited) {
        return;
      }
      this.$events.startLoading();
      const req = {
        gender: this.$refs.profile.local.gender,
        height: this.$refs.profile.local.height,
        weight: this.$refs.profile.local.weight,
      };
      console.log(JSON.stringify(req));

      try {
        await ApiActions.user.setProfile(req);
      } catch (e) {
        console.log(e.message);
        this.$events.alert(e.message);
      } finally {
        this.$events.stopLoading();
      }
    },
    next() {
      ScanProcess.mobileScanHeight = this.$refs.profile.local.height;
      this.setProfile().then(() => this.$events.goto('MobileScan2/Tutorial'));
    },
  },
};
</script>

<style scoped></style>
